import { render, staticRenderFns } from "./PrimeiraObservacao.vue?vue&type=template&id=46eda611"
import script from "./PrimeiraObservacao.vue?vue&type=script&lang=js"
export * from "./PrimeiraObservacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports